import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUsuarios } from 'services/servicioGet';
import { UsuarioBase } from 'utils/models/types';

interface UsuariosState {
  usuarios: UsuarioBase[];
  loadingUsuarios: boolean;
  errorUsuarios: string | null;
}
// Estado inicial del slice
const initialState: UsuariosState = {
  usuarios: [],
  loadingUsuarios: false,
  errorUsuarios: null,
};
// Thunk para obtener las salas
export const fetchUsuarios = createAsyncThunk<UsuarioBase[], void, { rejectValue: string }>(
  'usuarios/fetchUsuarios',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUsuarios();
      return response as UsuarioBase[];
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de salas
const usuariosSlice = createSlice({
  name: 'usuarios',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchUsuarios.pending, state => {
        state.loadingUsuarios = true;
        state.errorUsuarios = null;
      })
      .addCase(fetchUsuarios.fulfilled, (state, action) => {
        state.usuarios = action.payload;
        state.loadingUsuarios = false;
      })
      .addCase(fetchUsuarios.rejected, (state, action) => {
        state.loadingUsuarios = false;
        state.errorUsuarios = action.payload as string;
      });
  },
});

export default usuariosSlice.reducer;
